// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c2e6ccab","453":"1ec940ed","455":"11278180","977":"7f38ee72"}[chunkId] + ".chunk.js";
};